import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "badge badge-sm bg-gradient-danger me-1"
}
const _hoisted_3 = {
  key: 2,
  class: "badge badge-sm bg-gradient-info me-1"
}
const _hoisted_4 = { class: "badge badge-sm bg-gradient-success me-1" }
const _hoisted_5 = { class: "badge badge-sm bg-gradient-success me-1" }
const _hoisted_6 = { class: "badge badge-sm bg-gradient-warning me-1" }
const _hoisted_7 = { class: "badge badge-sm bg-gradient-warning me-1" }
const _hoisted_8 = { class: "p-3 card-body" }
const _hoisted_9 = ["data-timeline-axis-style"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.dark ? 'bg-gradient-dark' : ''])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pb-0 card-header", _ctx.dark ? 'bg-transparent' : ''])
    }, [
      _createElementVNode("h6", {
        class: _normalizeClass(_ctx.dark ? 'text-white' : '')
      }, _toDisplayString(_ctx.title), 3),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "text-sm",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.getRota.status_entrega==0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Rota não iniciada"))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " Iniciado ás " + _toDisplayString(_ctx.toHora(_ctx.getRota.inicio)), 1)),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, "# " + _toDisplayString(_ctx.getRota.id), 1),
        _createElementVNode("span", _hoisted_5, "Distância " + _toDisplayString(_ctx.getDistance(_ctx.getRota)) + "Km", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.toHora(_ctx.getRota.previsao_inicio)), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.toHora(_ctx.getRota.previsao_fim)), 1)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "timeline timeline-one-side",
        "data-timeline-axis-style": _ctx.dark ? 'dashed' : 'dotted'
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_9)
    ])
  ], 2))
}